import isBefore from 'date-fns/isBefore'
import {
  eventsRange,
  formatDateRange,
  formatEventTime,
  longMonthDayFormat,
  longMonthDayYearFormat,
  safeFormat,
  safeParse,
} from 'lib/family-cup-utils/event-dates'

const isPast = (date, referenceDate = new Date()) =>
  isBefore(safeParse(date), referenceDate)

export const getEventDates = (events, referenceDate = new Date()) => {
  if (events.length < 1) {
    return {
      dates: 'Event Schedule TBD',
      datesNoYear: 'Event Schedule TBD',
      time: null,
      started: false,
      ended: false,
    }
  }

  if (events.length === 1) {
    const [event] = events
    const { date } = event
    const isTimeIndicated = event.startTime != null && event.endTime != null

    return {
      dates: safeFormat(date, longMonthDayYearFormat),
      datesNoYear: safeFormat(date, longMonthDayFormat),
      time: isTimeIndicated ? formatEventTime(event) : null,
      started: isPast(date, referenceDate),
      ended: isPast(date, referenceDate),
    }
  }

  const { startDate, endDate } = eventsRange(events)

  return {
    dates: formatDateRange(startDate, endDate, {
      dateFormat: longMonthDayYearFormat,
      sameYearDateFormat: longMonthDayFormat,
    }),
    datesNoYear: formatDateRange(startDate, endDate, {
      dateFormat: longMonthDayFormat,
      sameYearDateFormat: longMonthDayFormat,
    }),
    time: null,
    started: isPast(startDate, referenceDate),
    ended: isPast(endDate, referenceDate),
  }
}
